import ruku from '@/assets/ruku.png'
const menuList = [
    {
        path: 'registerReceipt',
        title: '应收管理',
        resoureUrl: '',
        menuIcon: 'menu-icon2',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/RMS/invoicedAndShipped',
                title: '应收订单',
                menuName: '应收订单',
                resoureUrl: 'RMS/invoicedAndShipped',
            },
            {
                path: '/RMS/aging-report',
                title: '账龄报表',
                menuName: '账龄报表',
                resoureUrl: 'RMS/agingReport',
            },
            {
                path: '/registerReceipt',
                title: '回款登记',
                menuName: '回款登记',
                resoureUrl: 'sellAccount/registerReceipt',
            },
            {
                path: '/paymentConfirmation',
                title: '回款确认-废弃',
                menuName: '回款确认-废弃',
                resoureUrl: 'settlement/paymentConfirmation',
            },
            {
                path: '/bankMatch',
                title: '回款匹配',
                menuName: '回款匹配',
                resoureUrl: 'settlement/bankMatch',
            },
            {
                path: '/yingdaMatch',
                title: '回款导入匹配',
                menuName: '回款导入匹配',
                resoureUrl: 'settlement/yingdaMatch',
            },
            {
                path: '/receiptAudit',
                title: '回款审批',
                menuName: '回款审批',
                resoureUrl: 'sellAccount/receiptAudit',
            },
            {
                path: '/refoundAccount',
                title: '回款台账',
                menuName: '回款台账',
                resoureUrl: 'settlement/refoundAccount',
            },
            {
                path: '/invoiceDetail',
                title: '金税发票台账',
                menuName: '金税发票台账',
                resoureUrl: 'settlement/invoiceDetail',
            },
            {
                path: '/cancelAuditRecords',
                title: '回款撤销台账',
                menuName: '回款撤销台账',
                resoureUrl: 'settlement/cancelAuditRecords',
            },
            {
                path: '/receiptUnnamed',
                title: '不知名回款',
                menuName: '不知名回款',
                resoureUrl: 'sellAccount/receiptUnnamed',
            },
            {
                path: '/distributionRepayment',
                title: '分销回款',
                menuName: '分销回款',
                resoureUrl: 'sellAccount/distributionRepayment',
            },
            {
                path: '/internationalRepayment',
                title: '国际回款',
                menuName: '国际回款',
                resoureUrl: 'sellAccount/internationalRepayment',
            },
            {
                path: '/customerRefund',
                title: '客户退款',
                menuName: '客户退款',
                resoureUrl: 'sellAccount/customerRefund',
            },
            {
                path: '/returnReportInfo',
                title: '财务日报',
                menuName: '财务日报',
                resoureUrl: 'settlement/returnReportInfo',
            },
            {
                path: '/returnedMoneyNote',
                title: '票据管理',
                menuName: '票据管理',
                resoureUrl: 'settlement/returnedMoneyNote',
            }
        ]
    },
    {
        path: 'settlementBy',
        title: '进项管理',
        resoureUrl: "",
        menuIcon: 'menu-icon3',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/purchaseOrder',
                title: '采购订单台账',
                menuName: '采购订单台账',
                resoureUrl: 'paymentRequest/index',
            },
            {
                path: '/purchaseOrderSpecial',
                title: '四角订单台账',
                menuName: '四角订单台账',
                resoureUrl: 'paymentSpecialRequest/index',
            },
            {
                path: '/chargeBackList',
                title: '退换单记录',
                menuName: '退换单记录',
                resoureUrl: 'basicDataMaintenance/chargeBackList',
            },
            {
                path: '/settlementBy',
                title: '结算发起',
                menuName: '结算发起',
                resoureUrl: 'invoiceManagement/settlementBy',
            },
            {
                path: '/invoiceConfirm',
                title: '商务发票审核',
                menuName: '商务发票审核',
                resoureUrl: 'invoiceManagement/invoiceConfirm',
            },
            {
                path: '/invoiceApply',
                title: '财务发票审核',
                menuName: '财务发票审核',
                resoureUrl: 'invoiceManagement/invoiceApply',
            },
            {
                path: '/invoiceAccount',
                title: '进项发票台账',
                menuName: '进项发票台账',
                resoureUrl: 'invoiceManagement/invoiceAccount',
            },
            // {
            //     path: '/redInvoiceAccount',
            //     title: '红字发票',
            //     menuName: '红字发票',
            //     resoureUrl: 'invoiceManagement/redInvoiceAccount',
            // },
            {
                path: '/redInvoiceManagement',
                title: '红冲管理台账',
                menuName: '红冲管理台账',
                resoureUrl: 'invoiceManagement/redInvoiceManagement',
            },
            {
                path: '/purchaseAccount',
                title: '采购单台账',
                menuName: '采购单台账',
                resoureUrl: 'invoiceManagement/purchaseAccount',
            },
            {
                path: '/receiptReview',
                title: '签收单审核',
                menuName: '签收单审核',
                resoureUrl: 'invoiceManagement/receiptReview',
            },
            {
                path: '/featureIncome',
                title: '未来进项台账',
                menuName: '未来进项台账',
                resoureUrl: 'featureIncome/index',
            },
            {
                path: '/servicerVoucherClear',
                title: '会计凭证清帐台账',
                menuName: '会计凭证清帐台账',
                resoureUrl: 'basicDataMaintenance/servicerVoucherClear',
            }
        ]
    },
    {
        path: 'paymentConfirmationPlatForm',
        title: '供应商门户',
        resoureUrl: "",
        menuIcon: 'menu-icon4',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/serviceReceiptConfirm',
                title: '进项发票初审',
                menuName: '进项发票初审',
                resoureUrl: 'platformWork/serviceReceiptConfirm',
            },
            {
                path: '/platformOrderConfirm',
                title: '进项发票终审',
                menuName: '进项发票终审',
                resoureUrl: 'platformWork/orderConfirm',
            },
			{
			    path: '/platformInvoiceRegister',
			    title: '登记销项发票',
			    menuName: '登记销项发票',
			    resoureUrl: 'platformWork/invoiceRegister',
			},
            {
                path: '/platformInvoiceAccount',
                title: '进项发票台账',
                menuName: '进项发票台账',
                resoureUrl: 'platformWork/invoiceAccount',
            },
            {
                path: '/salesInvoiceAccount',
                title: '销项发票台账',
                menuName: '销项发票台账',
                resoureUrl: 'platformWork/salesInvoiceAccount',
            },
            {
                path: '/platformContract',
                title: '供应商合同',
                menuName: '供应商合同',
                resoureUrl: 'platformWork/platformContract',
            }
            ,
            {
                path: '/platformSettlementDetails',
                title: '结算明细',
                menuName: '结算明细',
                resoureUrl: 'platformWork/platformSettlementDetails',
            },
            {
                path: '/platformOrder',
                title: 'B2B销售订单',
                menuName: 'B2B销售订单',
                resoureUrl: 'platformWork/platformOrder',
            },
            {
                path: '/cpSupplierSalePurchaseOrder',
                title: '集采订单',
                menuName: '集采订单',
                resoureUrl: 'cpCentral/salePurchaseOrderDisplay',
            },
            {
                path: '/cpSupplierCpInvoice',
                title: '集采销项台账',
                menuName: '集采销项台账',
                resoureUrl: 'cpCentral/cpInvoiceDisplay',
            },
            {
                path: '/bRedInvoiceManagement',
                title: 'B类红字流程管理',
                menuName: 'B类红字流程管理',
                resoureUrl: 'platformWork/bRedInvoiceManagement',
            }
        ]
    },
    {
        path: 'paymentRequest',
        title: '请款管理',
        resoureUrl: "",
        menuIcon: 'menu-icon5',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/approval',
                title: '商务请款审批',
                menuName: '商务请款审批',
                resoureUrl: 'paymentRequest/approval',
            },
            {
                path: '/account',
                title: '商务请款台账',
                menuName: '商务请款台账',
                resoureUrl: 'paymentRequest/account',
            },
            {
                path: '/financeApproval',
                title: '财务请款审批',
                menuName: '财务请款审批',
                resoureUrl: 'paymentRequest/financeApproval',
            },
            {
                path: '/financeSapList',
                title: 'SAP支付',
                menuName: 'SAP支付',
                resoureUrl: 'paymentRequest/financeSapList',
            },
            {
                path: '/platformRequestAccount',
                title: '支付明细',
                menuName: '支付明细',
                resoureUrl: 'paymentRequest/platformRequestAccount',
            },
            {
                path: '/servicerRefundRegist',
                title: 'SP供应商退款',
                menuName: 'SP供应商退款',
                resoureUrl: 'paymentRequest/servicerRefundRegist',
            },
            {
                path: '/advanceVerifyList',
                title: '预付款核销台账',
                menuName: '预付款核销台账',
                resoureUrl: 'paymentRequest/advanceVerifyList',
            },
            {
                path: '/advanceVerifyAudit',
                title: '核销单据审核',
                menuName: '核销单据审核',
                resoureUrl: 'paymentRequest/advanceVerifyAudit',
            },
            {
                path: '/servicerFineAccount',
                title: 'SP供应商罚款台账',
                menuName: 'SP供应商罚款台账',
                resoureUrl: 'paymentRequest/servicerFineAccount',
            },

            {
                path: '/tenPaymentRecord',
                title: 'SP供应商缴费审核',
                menuName: 'SP供应商缴费审核',
                resoureUrl: 'basicDataMaintenance/tenPaymentRecord',
            },
            {
                path: '/paymentRequestAttachmentLedger',
                title: '请款附件台账',
                menuName: '请款附件台账',
                resoureUrl: 'paymentRequest/paymentRequestAttachmentLedger',
            },
            {
                path: '/bankReceiptRecognizeLedger',
                title: 'AI回单识别台账',
                menuName: 'AI回单识别台账',
                resoureUrl: 'paymentRequest/bankReceiptRecognizeLedger',
            },

        ]
    },
    {
        path: 'platformMessage',
        title: '基础数据维护',
        resoureUrl: "",
        menuIcon: 'menu-icon6',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/servicerMessage',
                title: '供应商信息',
                menuName: '供应商信息',
                resoureUrl: 'basicDataMaintenance/servicerMessage',
            },
            {
                path: '/platformQuotaManagement',
                title: '供应商额度',
                menuName: '供应商额度',
                resoureUrl: 'platformWork/platformQuotaManagement',
            },
            {
                path: '/platformQuery',
                title: '供应商查询',
                menuName: '供应商查询',
                resoureUrl: 'platformWork/platformQuery',
            },
            {
                path: '/servicerTenType',
                title: 'S单SP供应商',
                menuName: 'S单SP供应商',
                resoureUrl: 'basicDataMaintenance/servicerTenType',
            },
            {
                path: '/operationsWorkbench',
                title: '运维工作台',
                menuName: '运维工作台',
                resoureUrl: 'basicDataMaintenance/operationsWorkbench',
            },
            {
                path: '/returnedPaymentConfig',
                title: '齐心收款方式',
                menuName: '齐心收款方式',
                resoureUrl: 'basicDataMaintenance/returnedPaymentConfig',
            }
        ]
    },
	{
	    path: 'externalBusiness',
	    title: '外部业务',
	    resoureUrl: "",
	    menuIcon: 'menu-icon7',
	    requireAuth: true,
	    rotate: false,
	    children: [
	        {
	            path: '/hxbankFactoring',
	            title: '华夏银行保理',
	            menuName: '华夏银行保理',
	            resoureUrl: 'externalBusiness/hxbankFactoring',
	        },
	    ]
    },
    {
        path: 'supplierSettlement',
        title: 'SRM供应商结算',
        resoureUrl: "",
        menuIcon: 'menu-icon8',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/srmPurchaseOrder',
                title: '采购订单',
                menuName: '采购订单',
                resoureUrl: 'supplierSettlement/srmPurchaseOrder',
            },
            {
                path: '/srmBillAuditInfo',
                title: '对账单审核',
                menuName: '对账单审核',
                resoureUrl: 'supplierSettlement/srmBillAuditInfo',
            },
            {
                path: '/srmBillBook',
                title: '对账单台账',
                menuName: '对账单台账',
                resoureUrl: 'supplierSettlement/srmBillBook',
            },
            {
                path: '/paymentAudit',
                title: '请款审核',
                menuName: '请款审核',
                resoureUrl: 'supplierSettlement/paymentAudit',
            },
            {
                path: '/paymentBook',
                title: '请款台账',
                menuName: '请款台账',
                resoureUrl: 'supplierSettlement/paymentBook',
            },
            {
                path: '/srmPostingItemBook',
                title: '过账物料台账',
                menuName: '过账物料台账',
                resoureUrl: 'supplierSettlement/srmPostingItemBook',
            },
            {
                path: '/prepaidVerificationBook',
                title: '预付核销台账',
                menuName: '预付核销台账',
                resoureUrl: 'supplierSettlement/prepaidVerificationBook',
            },
            {
                path: '/srmRedInvoiceAccount',
                title: '红字发票',
                menuName: '红字发票',
                resoureUrl: 'supplierSettlement/srmRedInvoiceAccount',
            },
            {
                path: '/srmRefund',
                title: 'SRM供应商退款',
                menuName: 'SRM供应商退款',
                resoureUrl: 'supplierSettlement/srmRefund',
            },
            {
                path: '/finePayAudit',
                title: '罚款支付审核',
                menuName: '罚款支付审核',
                resoureUrl: 'supplierSettlement/finePayAudit',
            }
        ]
    },
    {
        path: 'platformSettlement',
        title: '商品平台结算',
        resoureUrl: "",
        menuIcon: 'menu-icon9',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/tabs',
                title: '平台结算',
                menuName: '平台结算',
                resoureUrl: 'platformSettlement/tabs',
            },
            {
                path: '/platformFeeAccrual',
                title: '平台费预提',
                menuName: '平台费预提',
                resoureUrl: 'platformSettlement/platformFeeAccrual',
            }
        ]
    },
    {
        path: 'systemManage',
        title: '系统管理',
        resoureUrl: "",
        menuIcon: 'menu-icon10',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/reqApiLog',
                title: '外部接口调用',
                menuName: '外部接口调用',
                resoureUrl: 'systemManage/reqApiLog',
            },
            {
                path: '/taxCategoryCache',
                title: '税分类缓存',
                menuName: '税分类缓存',
                resoureUrl: 'systemManage/taxCategoryCache',
            }
        ]
    },
    {
        path: 'b2bFinancialReport',
        title: 'B2B财务报表',
        resoureUrl: '',
        menuIcon: 'el-icon-coin',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/supplierSpInvoiceAmountReport',
                title: '供应商来票报表',
                menuName: '供应商来票报表',
                resoureUrl: 'paymentRequest/supplierSpInvoiceAmountReport',
            },
            {
                path: '/supplierInvoiceReport',
                title: 'SP供应商来票报表',
                menuName: 'SP供应商来票报表',
                resoureUrl: 'paymentRequest/supplierInvoiceReport',
            },
            {
                path: '/supplierBalanceReport',
                title: '供应商余额报表',
                menuName: '供应商余额报表',
                resoureUrl: 'paymentRequest/supplierBalanceReport',
            }
        ]
    },
    {
        path: 'cpSettlementManage',
        title: '集采结算管理',
        resoureUrl: '',
        menuIcon: 'el-icon-folder',
        requireAuth: true,
        rotate: false,
        cpSidebarStatic: true,
        children: [
            {
                path: '/cpSettlementSalePurchaseOrder',
                title: '集采订单',
                menuName: '集采订单',
                resoureUrl: 'cpCentral/salePurchaseOrderDisplay',
                routeName: '集采订单(结算)',
                metaTitle: '集采订单'
            },
            {
                path: '/cpSettlementCpInvoice',
                title: '集采进项台账',
                menuName: '集采进项台账',
                resoureUrl: 'cpCentral/cpInvoiceDisplay',
                routeName: '集采进项台账',
                metaTitle: '集采进项台账'
            },
            {
                path: '/cpSettlementPaymentSummaryLedger',
                title: '汇总付款台账',
                menuName: '汇总付款台账',
                resoureUrl: 'cpCentral/paymentSummaryLedger',
                routeName: '汇总付款台账',
                metaTitle: '汇总付款台账'
            },
            {
                path: '/cpSettlementPrepayOrderLedger',
                title: '预付单台账',
                menuName: '预付单台账',
                resoureUrl: 'cpCentral/prepayLedger',
                metaTitle: '预付单台账'
            },
            {
                // 追加到末尾：img_path=4，避免打乱库里已有 0~3 映射
                path: '/cpSettlementSalesInvoiceLedger',
                title: '集采销项台账',
                menuName: '集采销项台账',
                resoureUrl: 'cpCentral/cpSalesInvoiceLedger',
                routeName: '集采销项台账',
                metaTitle: '集采销项台账'
            },
            {
                // 追加到末尾：img_path=5，对应菜单 code=231306
                path: '/cpSettlementReceiptLedger',
                title: '集采回款台账',
                menuName: '集采回款台账',
                resoureUrl: 'cpCentral/cpReceiptLedger',
                routeName: '集采回款台账',
                metaTitle: '集采回款台账'
            },
            {
                // img_path=6，对应菜单 code=231307
                path: '/cpPaymentAttachmentLedger',
                title: '汇总付款附件',
                menuName: '汇总付款附件',
                resoureUrl: 'cpCentral/cpPaymentAttachmentLedger',
                routeName: '汇总付款附件',
                metaTitle: '汇总付款附件'
            }
        ]
    },
    {
        path: 'contractManage',
        title: 'AI服务费',
        resoureUrl: '',
        menuIcon: 'el-icon-document',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/servicerFrameworkAgreement',
                title: '服务商框架协议',
                menuName: '服务商框架协议',
                resoureUrl: 'contractManage/servicerFrameworkAgreement'
            },
            {
                path: '/supplierFrameworkAgreement',
                title: '供应商框架协议',
                menuName: '供应商框架协议',
                resoureUrl: 'contractManage/supplierFrameworkAgreement'
            },
            {
                path: '/aiServiceFee',
                title: '服务费管理',
                menuName: '服务费管理',
                resoureUrl: 'contractManage/aiServiceFee'
            },
            {
                path: '/aiServiceFeePayment',
                title: '支付记录',
                menuName: '支付记录',
                resoureUrl: 'contractManage/aiServiceFeePayment'
            }
        ]
    }
]


export default menuList
